// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"Uej3JFMR"};